import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Constant from '../../apis/constants';
import { images } from '../../assets/images';
import { renderImage } from '../helper/image';
const PageTitle = (props) => {
    return (
        <>
            {props && <div className="page_title_section" style={{ backgroundImage: `url(${props.image ? renderImage(props.image) : images.process2})` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="page_title_area">
                                <h1>{props.title}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
}

export default PageTitle;
